<style lang="stylus">
    .outputHtml-mask
        modal-mask()
        .outputHtml-modal
            width 480px
            max-width 100%
            .outputHtml-container
                .outputHtml-box
                    display flex
                    flex-wrap wrap
                    margin-bottom 8px
                    .outputHtml-optionbox-title
                        font-size 12px
                        line-height 24px
                        width 70px
                        overflow hidden
                        text-overflow ellipsis
                        white-space nowrap
                    .right
                        width calc(100% - 76px)
                        margin-left 6px
                        display flex
                        flex-wrap wrap
                        align-items center
                        .check-box-item
                            height 24px
                            padding 0 16px
                            border 1px solid var(--border-color-gray-10)
                            border-radius 6px
                            margin 0 16px 8px 0
                            display flex
                            align-items center
                            &:last-child
                                margin-right 0
                            &.checked
                                position relative
                                border-color var(--themeColor)
                                .tick-icon
                                    display block
                            &:hover
                                border-color var(--themeColor)
                            .tick-icon
                                display none
                                position absolute
                                top 0
                                right 0
                                height 18px
                                width 18px;
                                color var(--themeColor)
                            .vip-icon
                                margin-right 8px
                                width 12px
                                height 12px
                .outputHtml-otherbox
                    .right
                        .export-setting-html
                            position relative
                            margin-right 24px
                            position relative
                            margin-bottom 5px
                            display flex
                            align-items center
                            .vip-icon
                                margin-left 8px
                            &:last-child
                                margin-right 0
                            > span
                                margin-left 24px
                                line-height 24px
                            .item-checked
                                line-height 0
                                position absolute
                                display block
                                left 0
                                top 5px
                                width 16px
                                height 16px
                                .ivu-checkbox
                                    &:not(.ivu-checkbox-checked)
                                        .ivu-checkbox-inner
                                            background-color var(--bg-color-tertiary)
            .dialog-btnbox-normal
                margin-top 104px
</style>

<template>
    <div class="outputHtml-mask">
        <Dialog class="outputHtml-modal" :title="$t('title')" :showFooter="false" :isShow="true" @close="cancel">
            <div class="outputHtml-container">
                <div class="outputHtml-watermarkBox outputHtml-box">
                    <p class="outputHtml-optionbox-title" :title="$t('subTitle-name')">{{ $t("subTitle-name") }}</p>
                    <Input class="right" v-model="fileName" size="small" :placeholder="fileNameSync" :disabled="EDCONFIG.IS_SDK" />
                </div>
                <div class="outputHtml-watermarkBox outputHtml-box">
                    <p class="outputHtml-optionbox-title" :title="$t('subTitle-watermark')">{{ $t("subTitle-watermark") }}</p>
                    <div class="right">
                        <div
                            v-for="item in watermarkList"
                            :key="item.id"
                            class="check-box-item"
                            :class="{ checked: item.id == watermarkSetting }"
                            @click="changeWatermarkSetting(item.id)"
                        >
                            <VipIcon v-if="!vip && item.showVip" />
                            <span>{{ $t(item.name) }}</span>
                            <iconSymbol name="export-tick-top" class="tick-icon" />
                        </div>
                    </div>
                </div>
                <div class="outputHtml-otherbox outputHtml-box">
                    <p class="outputHtml-optionbox-title" :title="$t('subTitle-other')">{{ $t("subTitle-other") }}</p>
                    <div class="right">
                        <div v-for="item in exportSetting" :key="item.id" class="export-setting-html" @click="changeExportSetting(item.id)">
                            <span>
                                <span class="item-checked">
                                    <Checkbox :value="item.check" />
                                </span>
                                {{ $t(item.name) }}
                            </span>
                            <VipIcon v-if="!vip" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="dialog-btnbox-normal" :style="{ direction: !internal ? 'ltr' : 'rtl' }">
                <div @click="cancel">{{ $t("cancel") }}</div>
                <div class="dialog-btn-ok" @click="beforeConfirm">
                    <span>{{ $t("export") }}</span>
                </div>
            </div>
        </Dialog>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch, Inject } from "vue-property-decorator";
    import Dialog from "./Dialog.vue";

    declare var HtmlExport: any;

    const tipMap = {
        zh: "本内容由用户通过“亿图图示”发布，并不代表亿图软件的立场。",
        en: `This content is published by the user through "EdrawMax" and does not represent the position of EdrawMax.`,
        enSdk: `This content is published by the user through "Edraw.AI" and does not represent the position of Edraw.AI.`,
        fr: `Ce contenu est publié par l'utilisateur via "EdrawMax" et ne représente pas la position de EdrawMax.`,
        de: `Dieser Inhalt wird vom Benutzer über "EdrawMax" veröffentlicht und repräsentiert nicht die Position von EdrawMax.`,
        jp: `このコンテンツはユーザーが「EdrawMax」を通じて公開され、EdrawMaxの立場を代表するものではありません。`,
        es: `Este contenido es publicado por el usuario a través de "EdrawMax" y no representa la posición de EdrawMax.`,
        pt: `Este conteúdo é publicado pelo usuário através do "EdrawMax" e não representa a posição do EdrawMax.`,
        it: `Questo contenuto è pubblicato dall'utente tramite "EdrawMax" e non rappresenta la posizione di EdrawMax.`,
        tw: "此內容由用戶通過“EdrawMax”發布，並不代表EdrawMax的立場。",
        kr: '이 내용은 사용자가 "EdrawMax"를 통해 게시하였으며, 이는 EdrawMax의 입장을 대표하지 않습니다.',
    };
    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({
        components: {
            Dialog,
        },
    })
    export default class outputHtml extends Vue {
        @Inject()
        ["iviewInputBlur"];
        @Inject()
        ["fileRename"];
        fileName = window["_view"]._doc._fileName;
        exportSetting = [
            {
                id: 0,
                name: "export-title",
                check: false,
                trigger: "Title", // 埋点名
            },
            {
                id: 1,
                name: "export-preview",
                check: false,
                trigger: "Preview", // 埋点名
            },
            {
                id: 2,
                name: "export-gird",
                check: false,
                trigger: "Grid", // 埋点名
            },
        ];
        otherTrigger: Array<string> = [];
        watermarkSetting: number = 1;
        watermarkList = [
            {
                id: 0,
                name: "default",
            },
            {
                id: 1,
                name: "nonwatermark",
                showVip: true,
            },
        ];
        get fileNameSync() {
            return this.$store.state.ui.fileNameSync;
        }
        get userInfo() {
            return this.$store.state.user.userInfo;
        }
        // 用户偏好
        get customPreferContent() {
            return this.$store.state.ui.customPreferContent;
        }
        set customPreferContent(v) {
            this.$store.commit("setStatus", {
                type: "customPreferContent",
                data: v,
            });
        }
        changeWatermarkSetting(id: number) {
            this.watermarkSetting = id;
        }
        setExportHTMLWatermarkCustomPrefer() {
            let data = this.customPreferContent || {};
            if (data["defaultExportHTMLWatermark"] === this.watermarkSetting) return;
            Object.assign(data, { defaultExportHTMLWatermark: this.watermarkSetting });
            this.customPreferContent = data;
            let jsonStr = JSON.stringify(data);
            let params = {
                id: this.userInfo.user_id,
                token: this.userInfo.token,
                obj: { content: jsonStr },
            };
            this.$edApi.updateUserPrefer(params);
        }
        beforeConfirm() {
            this.fileRename(this.fileName).then(() => {
                this.confirm();
            });
        }
        confirm() {
            this.setExportHTMLWatermarkCustomPrefer();
            let needVip = this.exportSetting.some((item) => item.check);
            if ((this.watermarkSetting == 1 || needVip) && !this.vip) {
                let watermark = this.watermarkSetting ? "Nomark" : "Default",
                    other = this.otherTrigger.join("_");
                let triggerName = `html_${watermark}_${other}`;
                if (window.EDCONFIG.IS_SDK) {
                    triggerName += "_exportSth";
                }
                this.$openBuyPage(triggerName);
                return;
            }

            let view = window["_view"];
            this.$pcTrack("saveFileProcess_pickAnExportType", `fileType: html`);
            let htmlExport = new HtmlExport(view._doc, view.UI.getData("userName"), "", window.EDCONFIG.IS_SDK ? tipMap["enSdk"] : tipMap[this.lang]);
            htmlExport.SetOptions(this.exportSetting[0].check, this.exportSetting[1].check, this.exportSetting[2].check);
            try {
                htmlExport.Export("", this.watermarkSetting == 0);
                this.sensors.track("exportSuccess", {
                    Catalogues: "saveFileProcess",
                    savesource: "exportSave",
                    file_type: "html",
                    export_order: 1,
                });
            } catch (e) {}
            this.sensors.track("pickAnExportType", {
                Catalogues: "saveFileProcess",
                savesource: "exportSave",
                file_type: "html",
            });
            this.cancel();
        }
        cancel() {
            this.closeModal();
        }
        closeModal() {
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: false,
            });
        }
        changeExportSetting(id: number) {
            for (let index in this.exportSetting) {
                if (this.exportSetting[index].id == id) {
                    this.exportSetting[index].check = !this.exportSetting[index].check;
                    this.otherTrigger.push(this.exportSetting[index].trigger);
                    break;
                }
            }
        }

        mounted() {
            // 获取用户最后一次选择水印相关设置 默认无水印
            this.watermarkSetting = this.customPreferContent && this.customPreferContent["defaultExportHTMLWatermark"] == 0 ? 0 : 1;
        }

        created() {}
    }
</script>
<i18n>
{
  "zh": {
    "title": "导出为Html",
    "subTitle-name": "文件名称：",
    "subTitle-watermark": "水印设置：",
    "subTitle-other": "其他设置：",
    "export": "导出",
    "default": "默认",
    "nonwatermark": "无水印",
    "export-title": "导出标题",
    "export-preview": "页面预览面板",
    "export-gird": "导出网格",
    "cancel": "取消"
  },
  "en": {
    "title": "Export to Html",
    "subTitle-name": "File Name:",
    "subTitle-watermark": "Watermark settings:",
    "subTitle-other": "Other settings:",
    "export": "Export",
    "default": "Default",
    "nonwatermark": "No watermarks",
    "export-title": "Export title",
    "export-preview": "Page preview panel",
    "export-gird": "Export Grid",
    "cancel": "Cancel"
  },
  "fr": {
    "title": "Exporter en HTML",
    "subTitle-name": "Nom de fichier:",
    "subTitle-watermark": "Paramètres de filigrane:",
    "subTitle-other": "Autres paramètres:",
    "export": "Exporter",
    "default": "Par défaut",
    "nonwatermark": "Aucun filigrane",
    "export-title": "Exporter le titre",
    "export-preview": "Panneau d'aperçu de la page",
    "export-gird": "Exporter les grilles",
    "cancel": "Annuler"
  },
  "de": {
    "title": "Als HTML exportieren",
    "subTitle-name": "Dateiname:",
    "subTitle-watermark": "Wasserzeicheneinstellungen:",
    "subTitle-other": "Andere Einstellungen:",
    "export": "Exportieren",
    "default": "Standard",
    "nonwatermark": "Kein Wasserzeichen",
    "export-title": "Titel exportieren",
    "export-preview": "Seitenvorschau-Leiste",
    "export-gird": "Raster exportieren",
    "cancel": "Abbrechen"
  },
  "jp": {
    "title": "Htmlにエクスポート",
    "subTitle-name": "ファイル名：",
    "subTitle-watermark": "透かし設定: ",
    "subTitle-other": "その他の設定: ",
    "export": "エクスポート",
    "default": "デフォルト",
    "nonwatermark": "透かしなし",
    "export-title": "タイトルをエクスポート",
    "export-preview": "ページプレビューパネル",
    "export-gird": "グリッド線をエクスポート",
    "cancel": "キャンセル"
  },
  "es": {
    "title": "Exportar a HTML",
    "subTitle-name": "Nombre de Archivo:",
    "subTitle-watermark": "Configuración de marca de agua:",
    "subTitle-other": "Otros ajustes:",
    "export": "Exportar",
    "default": "Estándar",
    "nonwatermark": "Sin marca de agua",
    "export-title": "Exportar título",
    "export-preview": "Panel de vista previa de página",
    "export-gird": "Exportar la Cuadrícula",
    "cancel": "Cancelar"
  },
  "pt": {
    "title": "Exportar para HTML",
    "subTitle-name": "Nome do Arquivo:",
    "subTitle-watermark": "Configurações de marca d'água:",
    "subTitle-other": "Outras configurações:",
    "export": "Exportar",
    "default": "Padrão",
    "nonwatermark": "Sem marcas d'água",
    "export-title": "Exportar título",
    "export-preview": "Painel de pré-visualização de página",
    "export-gird": "Exportar grelha",
    "cancel": "Cancelar"
  },
  "it": {
    "title": "Esporta in HTML",
    "subTitle-name": "Nome File:",
    "subTitle-watermark": "Impostazioni filigrana:",
    "subTitle-other": "Altre impostazioni:",
    "export": "Esporta",
    "default": "Predefinito",
    "nonwatermark": "Nessuna filigrana",
    "export-title": "Titolo di esportazione",
    "export-preview": "Pannello di anteprima delle pagine",
    "export-gird": "Griglia di esportazione",
    "cancel": "Annulla"
  },
  "tw": {
    "title": "匯出為Html",
    "subTitle-name": "檔案名稱：",
    "subTitle-watermark": "浮水印設定：",
    "subTitle-other": "其他設定:",
    "export": "導出",
    "default": "默認",
    "nonwatermark": "無水印",
    "export-title": "匯出標題",
    "export-preview": "頁面預覽面板",
    "export-gird": "匯出網路",
    "cancel": "取消"
  },
  "kr": {
    "title": "Html로 내보내기",
    "subTitle-name": "파일 이름:",
    "subTitle-watermark": "워터마크 설정:",
    "subTitle-other": "기타 설정:",
    "export": "내보내기",
    "default": "기본",
    "nonwatermark": "워터마크 없음",
    "export-title": "내보내기 타이틀",
    "export-preview": "페이지 미리보기 패널",
    "export-gird": "내보내기 그리드",
    "cancel": "취소"
  },
  "id": {
    "subTitle-watermark": "Pengaturan watermark:",
    "subTitle-other": "Pengaturan lainnya:"
  }
}
</i18n>
